import util from "@/common/js/util";
import constants from "@/common/constants";


const currency = {
    async getList() {
        return util.cache({
            key: constants.currencyStoreKey,
            fetch: () => util.axios.post('/public/queryAllCurrency'),
            handle: res =>(res.module || []).map(e=>({
                value:e.key,
                label:e.label,
                key:e.key
            })) ,
        });
    }
}

export default currency;



// WEBPACK FOOTER //
// ./src/common/api/currency.js